import React from 'react'
import styled from 'styled-components'
import PPMori from "../assets/fonts/PPMori-Regular.otf";

export const ReachOut = () => {
  return (
    <Container>
        <Main>
            <SubText>For support, please e-mail us at</SubText>
            <Text>hello@cosmetic-iq.com</Text>
            <ReachoutButton href="mailto:hello@cosmetic-iq.com">
                           
                            <ReachoutText>Reach out</ReachoutText>
                        </ReachoutButton>
        </Main>
    </Container>
  )
}


const Container = styled.div`
// width: 1,228px;
flex:1;


padding: 30px;
gap: 30px;

border: 0px 1px 0px 0px;
height:88%;
flex-grow: 1; 

`
const Main = styled.div`

// width: 1,228px;
padding: 24px;

height:100%;

gap: 32px;
border-radius: 24px;
background: #FFFFFF;
overflow:scroll;
box-shadow: 0px 0px 24px 0px #2F323705;

display:flex;
align-items:center;
flex-direction:column;
justify-content:center;
  flex-grow: 1; 


opacity: 0px;
`
const SubText = styled.p`
font-size: 16px;
color: #2F323799;
line-height: 120%;
letter-spacing: 0%;
`

const Text = styled.p`
color: #2F3237;
font-size: 48px;
font-weight: 500;
line-height: 110.00000000000001%;
letter-spacing: -1%;
margin:0;
`


const ReachoutButton = styled.a`
width:107px;
height:40px;
font-family:PPMori;
color: inherit;  
text-decoration: none;

padding: 8px 12px 8px 12px;
gap: 8px;
border-radius: 64px;
border:none;
background: linear-gradient(90deg, #DCFFAD 0%, #F6FFDB 50%, #BDDEFF 100%);

display:flex;
flex-direection:row;
cursor:pointer;
align-items:center;
justify-content:center;

`

const ReachoutText = styled.p`
@font-face {
    src: url(${PPMori}) format('truetype');
   font-family:PPMori;
  }

font-family:PPMori;
font-size: 14px;
font-weight: 700;
line-height: 16.8px;
letter-spacing: -0.01em;
text-align: center;
text-underline-position: from-font;
text-decoration-skip-ink: none;
color:background: #2F3237;

`